module.exports = __webpack_public_path__ + "static/media/brand-refresh-arrow-left-disabled.1e801caf.svg";